module.exports = __webpack_public_path__ + "static/img/daikuan.a696004.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/daikuan.png
// module id = cQTr
// module chunks = 128